import { GLOWApiClient } from '../apiClients/GLOWClient';

type AppointmentId = number | string;

export const appointmentWorkflowApi = GLOWApiClient.injectEndpoints({
  endpoints: (build) => ({
    confirmAppointment: build.mutation({
      query: (id: AppointmentId) => ({
        url: `/api/appointments/${id}/confirm/`,
        method: 'POST',
      }),
    }),
    modifyAndConfirmAppointment: build.mutation({
      query: ({ id, ...body }: { id: AppointmentId; [key: string]: unknown }) => ({
        url: `/api/appointments/${id}/modify-and-confirm/`,
        method: 'POST',
        body,
      }),
    }),
    proposeAppointment: build.mutation({
      query: ({ id, ...body }: { id: AppointmentId; [key: string]: unknown }) => ({
        url: `/api/appointments/${id}/propose/`,
        method: 'POST',
        body,
      }),
    }),
    cancelAppointment: build.mutation({
      query: ({ id, reason }: { id: AppointmentId; reason: string }) => ({
        url: `/api/appointments/${id}/cancel/`,
        method: 'POST',
        body: { reason },
      }),
    }),
    acceptProposal: build.mutation({
      query: (id: AppointmentId) => ({
        url: `/api/appointment-proposals/${id}/accept/`,
        method: 'POST',
      }),
    }),
    cancelProposal: build.mutation({
      query: ({ id, reason }: { id: AppointmentId; reason?: string }) => ({
        url: `/api/appointment-proposals/${id}/cancel/`,
        method: 'POST',
        body: { reason },
      }),
    }),
    getProposalHistory: build.query({
      query: (appointmentId: AppointmentId) =>
        `/api/appointments/${appointmentId}/proposal-history/`,
    }),
  }),
});

export const {
  useConfirmAppointmentMutation,
  useModifyAndConfirmAppointmentMutation,
  useProposeAppointmentMutation,
  useCancelAppointmentMutation,
  useAcceptProposalMutation,
  useCancelProposalMutation,
  useGetProposalHistoryQuery,
} = appointmentWorkflowApi;
